export enum AccountFormatPatterns {
    CPFNumber = '###.###.###-##',
    PagoMovilPhone = '#### #######',
}


// WEBPACK FOOTER //
// ./src/model/types/account-format-patterns.ts